import { Group, MantineTheme } from "@mantine/core";
import { CircleFilledIcon } from "@mcurros2/microm";
import { IconAlertHexagonFilled, IconAlertTriangleFilled, IconUser, IconUsersPlus } from "@tabler/icons-react";
import { ReactNode } from "react";


export function ClientesPorTiendaColumnsOverrides(theme: MantineTheme) {
    return {
        // Ruta compartida
        5: {
            render: (value: unknown) => (value === "true") ? <Group sx={{ gap: 0 }}>
                <CircleFilledIcon backColor={theme.colors.teal[8]} width="1.3rem" icon={<IconUsersPlus size="0.9rem" />}></CircleFilledIcon>Compartida
            </Group> : <Group sx={{ gap: 0 }}>
                <CircleFilledIcon backColor={theme.colors.grape[8]} width="1.3rem" icon={<IconUser size="0.9rem" />}></CircleFilledIcon>Exclusiva
            </Group> },
        // Productos
        6: { render: (value: unknown) => (!value || value === '0') ? <Group sx={{ gap: '.5rem' }}><IconAlertTriangleFilled style={{ color: theme.colors.yellow[8] }} size="1.3rem" />Sin productos</Group> : value as ReactNode },
        // Servicios
        7: { render: (value: unknown) => (!value) ? <Group sx={{ gap: '.5rem' }}><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin servicios</Group> : value as ReactNode },
    }

}